import React from 'react';

export default () => (
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M16.864 16.864C20.3787 13.3492 20.3787 7.65081 16.864 4.13605C13.3492 0.621292 7.65076 0.621341 4.13605 4.13605C0.621341 7.65076 0.621292 13.3492 4.13605 16.864C7.65081 20.3787 13.3492 20.3787 16.864 16.864ZM4.93159 11.3438L9.65625 11.3438L9.65629 16.0685H11.3438L11.3438 11.3438L16.0685 11.3438V9.65629L11.3438 9.65625L11.3438 4.93159H9.65629L9.65634 9.65634L4.93159 9.65629V11.3438Z" fill="currentColor" />
  </svg>
);